import { useLocation } from "react-router";
import { useEffect } from "react";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}
const useRefresh = (callback: () => void) => {
    const refresh = useQuery().get('refresh')

    useEffect(() => {
        if (refresh) {
            callback()
        }
    },[refresh])
    return null
}
export default useRefresh